<template>
  <div
    class="flex items-center py-5"
    :class="{
      'gap-x-5 border border-[#CCC]/50 rounded-xl px-[30px]': !embedded,
      'gap-x-5 pl-[30px] pr-5': embedded,
    }"
  >
    <div
      class="min-w-20 max-w-20 h-20 bg-[#FAFAFA] border border-[#CCC]/50 rounded-md flex items-center justify-center"
    >
      <ThumbnailIcon
        :type="props.file.type"
        :image-url="props.file.asset?.previewImageUrl"
        :icon-size="46"
      />
    </div>

    <div class="w-full min-w-0 flex flex-col">
      <div
        v-if="!embedded && !('copyright' in props.file)"
        class="font-secondary text-[12px] leading-[16px] text-gray-500 mb-1.5"
      >
        Potential infringing work
      </div>

      <div class="flex items-center justify-between">
        <div
          class="font-primary font-medium text-[17px] leading-[26px] text-gray-800"
        >
          {{ props.file.name }}
        </div>

        <UiButton
          v-if="'copyright' in props.file"
          class="shrink-0"
          @click="handleViewRegistration"
        >
          View registration
        </UiButton>
      </div>

      <div v-if="'copyright' in props.file" class="flex mt-3 gap-x-10">
        <div class="flex flex-col gap-1.5">
          <div class="flex items-center gap-1.5">
            <Icon name="Dacr" :size="14" class="fill-gray-500" />

            <div
              class="font-secondary text-[12px] leading-[16px] text-gray-500"
            >
              Dacr Timestamp
            </div>
          </div>

          <div class="font-secondary text-[14px] leading-[20px] text-gray-800">
            {{
              formatTimestamp(props.file.copyright.registrations[0]?.timestamp)
            }}
          </div>
        </div>

        <div class="flex flex-col gap-1.5">
          <div class="font-secondary text-[12px] leading-[16px] text-gray-500">
            Dacr Token ID
          </div>
          <div class="font-secondary text-[14px] leading-[20px] text-gray-800">
            {{ props.file.copyright.id }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ThumbnailIcon, Icon, UiButton } from '@dacr/ui'
import { formatTimestamp } from '@/shared/utils/datetime'
import { useRouter } from 'vue-router'
import type { ReportFile } from '@/shared/graphql/router/graphql'

const props = defineProps<{
  file: ReportFile
  embedded?: boolean
}>()

const router = useRouter()

const handleViewRegistration = () => {
  if (!('copyright' in props.file)) return

  router.push(`/file/${props.file.copyright.id}`)
}
</script>
